// libs
import React, { memo } from 'react';

// global components
import SubNav, { SUB_NAV_PLACEMENT } from 'shared/components/SubNav';

// components
import SubMenu from './components/SubMenu';

// constants
import { TEXTS } from './constants';
import { TAB_INDEX } from 'shared/constants';

// styles
import { AuthContainer, TextContainer, IconWrapper } from './styles';

// icon
import { useStoreIcon, IconName } from 'shared/icons';
import { useDomainConfig } from 'shared/domainConfig/context/context';

function Auth() {
  const AccountMoreIcon = useStoreIcon(IconName.ACCOUNT);
  const { HEADER_ICON_LAYOUT } = useDomainConfig();
  const isColumn = HEADER_ICON_LAYOUT === 'column';

  return (
    <SubNav subMenu={<SubMenu />} placement={SUB_NAV_PLACEMENT.RIGHT}>
      <AuthContainer isColumn={isColumn} data-at="my_account_popup_dweb">
        <IconWrapper isColumn={isColumn}
          tabIndex={TAB_INDEX.ACTION_INVISIBILITY}
          className="megamenu-svg"
        >
          <AccountMoreIcon />
        </IconWrapper>
        <TextContainer>{TEXTS.ACCOUNT}</TextContainer>
      </AuthContainer>
    </SubNav>
  );
}

export default memo(Auth);
